import { BaseText, Button, Notification, Title } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import useAfterAuthenticationRedirect from 'hooks/useAfterAuthenticationRedirect';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkNotifications, RESULTS } from 'react-native-permissions';
import { useAuthStore } from 'stores/authStore';
import { useUiStore } from 'stores/uiStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { FooterWrapper, MainWrapper } from 'styles/ModalStackContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';

const LogoIcon = () => <Icon name="AimoApp-Rounded" size="m" />;

const PushNotifications = () => {
  const { t } = useTranslation();
  const { setOnboardingCompleted } = useAfterAuthenticationRedirect();

  const handleAllow = async () => {
    if (!isWeb) {
      const { status } = await checkNotifications();
      if (status === RESULTS.BLOCKED) {
        useUiStore.getState().setSheetModal('notificationSettings');
        return;
      }
      await useAuthStore.getState().fetchDeviceToken();
    }
    setOnboardingCompleted();
  };

  return (
    <>
      <MainWrapper vAlignCenter={true}>
        <StyledWrapper maxWidth={350} center mb={30}>
          <Notification
            title={t('onboarding.parkingReminderTitle')}
            text={t('onboarding.parkingReminder')}
            time={t('time.now')}
            iconComponent={LogoIcon}
            testID="onboarding-reminder-note"
          />
        </StyledWrapper>
        <StyledWrapper maxWidth={350} center mb={35}>
          <Title
            {...testIdentifiers('onboarding-pushnotification-title')}
            center>
            {t('onboarding.allowPushNotifications')}
          </Title>
        </StyledWrapper>
        <StyledWrapper maxWidth={250} center mb={50}>
          <BaseText testID="onboarding-pushnotification-description" center>
            {t('onboarding.allowPushNotificationsDescription')}
          </BaseText>
        </StyledWrapper>
      </MainWrapper>
      <FooterWrapper>
        <StyledWrapper maxWidth={350} center mb={10}>
          <Button
            text={t('button.continue')}
            size="l"
            buttonType="secondary"
            onPress={handleAllow}
            testID="onboarding-allow-notes-button"
          />
        </StyledWrapper>
      </FooterWrapper>
    </>
  );
};

export default PushNotifications;
